<template>
  <div class="big platformCoupon-list">
    <div class="container" style="padding: 10px 20px 20px 20px">
      <div class="top-header">
        <div class="search-box">
          <!-- 券包名称 -->
          <div class="item">
            <span>券包名称</span>
            <div class="item-content">
              <el-input
                v-model="searchForm.group_coupon_name"
                size="small"
                clearable
                @keyup.enter.native="seachEnterFun"
                placeholder="请输入"
              ></el-input>
            </div>
          </div>

          <!-- 状态 -->
          <div class="item" style="margin-left: 10px">
            <span>状态</span>
            <div class="item-content">
              <el-radio-group v-model="searchForm.status" @change="getList">
                <el-radio :label="''">全部</el-radio>
                <el-radio :label="1">发放中</el-radio>
                <el-radio :label="0">已停发</el-radio>
              </el-radio-group>
            </div>
            <el-button
              type="primary"
              size="small"
              style="margin-left: 20px"
              @click="getList"
              >查询</el-button
            >
          </div>
        </div>
        <!-- 添加券包 -->
        <div style="margin-bottom: 10px">
          <el-button
            type="primary"
            size="medium"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('1947') : false
            "
            @click="addOrEditBtn(-1)"
            >添加券包</el-button
          >
        </div>
      </div>
      <div style="border: solid 1px #c9cbd6">
        <el-table
          v-loading="tableLoading"
          :data="couponList"
          tooltip-effect="dark"
          style="width: 100%; min-width: 1000px"
          :header-cell-style="{ background: '#F5F5F5' }"
        >
          <el-table-column
            v-for="item in tableHeader"
            :key="item.prop"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            :fixed="item.fixed"
          >
            <template slot-scope="scope">
              <div
                v-if="item.prop == 'console_coupon'"
                style="display: flex; align-items: center; flex-wrap: wrap"
              >
                <div v-for="(item, index) in scope.row[item.prop]" :key="index">
                  <span> {{ item.coupon_name }}</span>
                  <span v-if="item.status_str">（{{ item.status_str }}）</span>
                  <span v-if="index != scope.row.console_coupon.length - 1"
                    >,</span
                  >
                </div>
              </div>

              <div
                v-else-if="item.prop == 'shop_coupon'"
                style="display: flex; align-items: center; flex-wrap: wrap"
              >
                <div v-for="(item, index) in scope.row[item.prop]" :key="index">
                  <span> {{ item.coupon_name }}</span>
                  <span v-if="item.status_str">（{{ item.status_str }}）</span>
                  <span v-if="index != scope.row.shop_coupon.length - 1"
                    >,</span
                  >
                </div>
              </div>

              <div v-else-if="item.prop == 'create_time'">
                {{ scope.row[item.prop] | dateTimeFormat }}
              </div>

              <div v-else-if="item.prop == 'status'">
                {{ scope.row[item.prop] | statusText }}
              </div>

              <div v-else>
                {{ scope.row[item.prop] }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            label="操作"
            width="280"
            align="center"
            fixed="right"
          >
            <template slot-scope="scope">
              <template v-if="scope.row.is_overdue != 1">
                <el-button
                  v-if="scope.row.status == 1"
                  type="text"
                  size="medium"
                  @click="issueBtn(scope.row)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1949')
                      : false
                  "
                  >发放</el-button
                >

                <el-button
                  type="text"
                  @click="logListBtn(scope.row)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1951')
                      : false
                  "
                  >发放记录</el-button
                >

                <el-button
                  type="text"
                  @click="addOrEditBtn(scope.row.group_id)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1948')
                      : false
                  "
                  >编辑</el-button
                >

                <el-button
                  type="text"
                  @click="openLink(scope.row)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1948')
                      : false
                  "
                  >链接</el-button
                >

                <el-button
                  v-if="scope.row.status == 1"
                  type="text"
                  @click="updateStatus(scope.row, 0)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1986')
                      : false
                  "
                  >停发</el-button
                >
                <el-button
                  v-else
                  type="text"
                  @click="updateStatus(scope.row, 1)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1986')
                      : false
                  "
                  >恢复</el-button
                >
                <el-button
                  type="text"
                  @click="toStatistics(scope.row)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('2031')
                      : false
                  "
                  >统计</el-button
                >
              </template>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <pagination
        v-show="totalNum > 0"
        :total="totalNum"
        :page.sync="pagination.page"
        :limit.sync="pagination.pageNumber"
        @pagination="getList"
      />
    </div>
    <!-- 发放记录 -->
    <el-dialog title="发放记录" :visible.sync="couponVisible" width="800px">
      <div style="padding: 20px 20px 0">
        <div class="search-box">
          <!-- 券包名称 -->
          <div class="item">
            <span>券包名称</span>
            <div class="item-content">
              <el-input
                v-model="couponVisibleForm.group_coupon_name"
                size="small"
                clearable
                placeholder="请输入"
              ></el-input>
            </div>
          </div>

          <!-- 领取人手机号 -->
          <div class="item">
            <span>领取人手机号</span>
            <div class="item-content">
              <el-input
                v-model="couponVisibleForm.phone"
                size="small"
                clearable
                placeholder="请输入"
              ></el-input>
            </div>
            <el-button
              type="primary"
              size="small"
              style="margin-left: 20px"
              @click="searchCouponVisibleList"
              >查询</el-button
            >
          </div>
        </div>
        <el-table
          v-loading="couponVisibleTableLoading"
          :data="couponVisibleTableData"
          :key="Math.random()"
          height="530px"
          border
          tooltip-effect="dark"
          :header-cell-style="{ background: '#F5F5F5' }"
        >
          <el-table-column
            v-for="item in couponVisibleTableHeader"
            :key="item.prop"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            :fixed="item.fixed"
          >
            <template slot-scope="scope">
              <div v-if="item.prop == 'create_time'">
                {{ scope.row[item.prop] | dateTimeFormat }}
              </div>

              <div v-else-if="item.prop == 'get_type'">
                <span v-if="scope.row[item.prop] == 1"
                  >平台发放<span v-if="scope.row.user_name"
                    >（{{ scope.row.user_name }}）</span
                  ></span
                >
                <span v-else>自主领取</span>
              </div>

              <div v-else>
                {{ scope.row[item.prop] }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination
        v-show="couponVisibleTotalNum > 0"
        :total="couponVisibleTotalNum"
        :page.sync="couponVisiblePagination.page"
        :limit.sync="couponVisiblePagination.pageNumber"
        @pagination="getCouponList"
      />
    </el-dialog>

    <!-- 发放 -->
    <el-dialog
      title="发放"
      :visible.sync="issueVisible"
      width="800px"
      custom-class="platformCoupon-issue"
    >
      <el-form
        :model="issueVisibleForm"
        :rules="rules"
        ref="issueFormRef"
        label-width="110px"
        style="padding: 10px"
      >
        <el-form-item label="手机号" prop="phone">
          <el-input
            type="textarea"
            v-model="issueVisibleForm.phone"
            rows="8"
            placeholder="输入领取人员手机号，多个用英文逗号隔开"
          ></el-input>
        </el-form-item>

        <el-form-item label="是否发送短信" prop="is_msg" class="is-msg">
          <el-radio-group v-model="issueVisibleForm.is_msg">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item
          v-if="issueVisibleForm.is_msg == 1"
          label="短信内容"
          prop="msg"
        >
          <el-input
            type="textarea"
            v-model="issueVisibleForm.msg"
            rows="5"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button @click="resetForm('issueFormRef')">取消</el-button>
          <el-button type="primary" @click="submitForm('issueFormRef')"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 链接 -->
    <el-dialog
      title="链接"
      :visible.sync="dialogVisible"
      width="30%"
      center
      @close="handleClose"
    >
      <div style="padding: 20px">
        <div class="qrcode-container">
          <!-- 公众号二维码 -->
          <div class="qrcode-item">
            <el-image
              class="qrcode-img"
              :src="linkInfo.wechat_link_url_qrcode"
              :preview-src-list="[linkInfo.wechat_link_url_qrcode]"
              fit="contain"
            ></el-image>
            <el-button
              type="primary"
              size="small"
              @click="
                downloadImage(linkInfo.wechat_link_url_qrcode, '公众号二维码')
              "
            >
              下载
            </el-button>
          </div>

          <!-- 小程序二维码 -->
          <div class="qrcode-item">
            <el-image
              class="qrcode-img"
              :src="linkInfo.applet_link_url_qrcode"
              :preview-src-list="[linkInfo.applet_link_url_qrcode]"
              fit="contain"
            ></el-image>
            <el-button
              type="primary"
              size="small"
              @click="
                downloadImage(linkInfo.applet_link_url_qrcode, '小程序二维码')
              "
            >
              下载
            </el-button>
          </div>
        </div>

        <div class="link-container">
          <div class="link-item">
            <span>H5链接：</span>
            <el-input
              v-model="linkInfo.h5_link_url"
              readonly
              size="small"
              style="width: 70%; margin-right: 10px"
            ></el-input>
            <el-button
              type="success"
              size="small"
              @click="copyText(linkInfo.h5_link_url)"
            >
              复制
            </el-button>
          </div>

          <div class="link-item">
            <span>小程序链接：</span>
            <el-input
              v-model="linkInfo.applet_link_url"
              readonly
              size="small"
              style="width: 70%; margin-right: 10px"
            ></el-input>
            <el-button
              type="success"
              size="small"
              @click="copyText(linkInfo.applet_link_url)"
            >
              复制
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import _ from "lodash";
import dayjs from "dayjs";
import marketing from "@/api/marketing.js";
import Pagination from "@/components/Pagination/index";
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10,
      },
      searchForm: {
        group_coupon_name: "",
        status: "",
      },
      tableHeader: [
        {
          label: "券包名称",
          prop: "group_coupon_name",
          width: "180",
          align: "center",
          fixed: "left",
        },
        {
          label: "券包描述",
          prop: "group_coupon_desc",
          width: "180",
          align: "center",
          fixed: false,
        },
        {
          label: "诊疗优惠券",
          prop: "console_coupon",
          width: "300",
          align: "center",
          fixed: false,
        },
        {
          label: "商城优惠券",
          prop: "shop_coupon",
          width: "300",
          align: "center",
          fixed: false,
        },
        {
          label: "创建时间",
          prop: "create_time",
          width: "200",
          align: "center",
          fixed: false,
        },
        {
          label: "状态",
          prop: "status",
          width: "auto",
          align: "center",
          fixed: false,
        },
      ],
      couponList: [],
      ///
      couponVisible: false,
      couponVisibleTableLoading: false,
      couponVisibleForm: {
        group_id: "",
        group_coupon_name: "",
        phone: "",
      },
      couponVisibleTotalNum: 0,
      couponVisiblePagination: {
        page: 1,
        pageNumber: 10,
      },
      couponVisibleTableHeader: [
        {
          label: "领取人手机号",
          prop: "phone",
          width: "auto",
          align: "center",
          fixed: "left",
        },
        {
          label: "发放时间",
          prop: "create_time",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "领取方式",
          prop: "get_type",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "券包名",
          prop: "group_coupon_name",
          width: "auto",
          align: "center",
          fixed: false,
        },
      ],
      couponVisibleTableData: [],
      issueVisible: false,
      issueVisibleForm: {
        phone: "",
        is_msg: 1,
        msg:
          "您好，歧黄医官赠送您优惠券，点击查看qhyiguan.com/5onT。拒收请回复R",
        group_id: "",
      },
      rules: {
        phone: [{ required: true, message: "请填写", trigger: "blur" }],
        is_msg: [{ required: true, message: "请选择", trigger: "change" }],
        msg: [{ required: true, message: "请填写", trigger: "blur" }],
      },
      dialogVisible: false,
      linkInfo: {
        wechat_link_url_qrcode: "",
        h5_link_url: "",
        applet_link_url_qrcode: "",
        applet_link_url: "",
      },
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD");
    },
    dateTimeFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:mm:ss");
    },

    usedText(val) {
      switch (val) {
        case 0:
          return "未使用";
        case 1:
          return "已使用";
        case 2:
          // expire_time
          return "已过期";
      }
    },
    getTypeText(val) {
      switch (val) {
        case 1:
          return "自主领取";
        case 2:
          return "积分兑换";
        case 3:
          return "养生卡赠送";
        case 4:
          return "分享领取";
        case 5:
          return "引流流动赠送";
        case 6:
          return "平台发放";
        case 7:
          return "邀请用户赠送";
        case 8:
          return "新用户赠送";
      }
    },
    statusText(val) {
      switch (val) {
        case 1:
          return "发放中";
        case 0:
          return "已停发";
      }
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      let params = Object.assign({}, this.pagination, this.searchForm);
      this.tableLoading = true;
      marketing.platformCouponGroupList(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.couponList = data.list;
          this.totalNum = data.total;
          this.tableLoading = false;
        }
      });
    },
    seachEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.getList();
      }
    },

    // 发放
    issueBtn(row) {
      this.issueVisibleForm = {
        phone: "",
        is_msg: 1,
        msg:
          "您好，歧黄医官赠送您优惠券，点击查看qhyiguan.com/5onT。拒收请回复R",
        group_id: row.group_id,
      };
      this.issueVisible = true;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.issueVisibleForm);
          marketing.checkCouponGroupPhone(params).then((res) => {
            let { code, data } = res;
            if (code == 0) {
              let { nobody, sending } = data;
              if (nobody.length) {
                let nobody_str = nobody.length ? nobody.join(",") : "";
                let str_html = `
                <div style="text-align: left;">
                    <div>没找到用户${nobody_str}</div>
                </div>
                `;
                this.$confirm(str_html, "提示", {
                  dangerouslyUseHTMLString: true,
                  confirmButtonText: "知道了",
                  showCancelButton: false,
                })
                  .then(() => {
                    this.issueVisible = false;
                  })
                  .catch((action) => {
                    this.issueVisible = false;
                  });
                return;
              }

              if (sending.length) {
                let sending_str = sending.length ? sending.join(",") : "";
                let str_html =
                  '<div style="text-align: left;max-height:500px;overflow: auto;">';
                str_html += `
                        <div style=" word-wrap: break-word;overflow-wrap: break-word; ">已向${sending_str}发放过该券包</div>
                        <div>若用户反馈未收到，请在【发放记录】中找到该用户查看发放状态。</div>
                        <div>若需要再次向用户发放券包，请点击【确定】继续</div>
                    </div>
                    `;
                this.$confirm(str_html, "提示", {
                  dangerouslyUseHTMLString: true,
                })
                  .then(() => {
                    let params = Object.assign({}, this.issueVisibleForm);
                    const loading = this.$loading();
                    marketing
                      .grantPlatformCouponGroup(params)
                      .then((res) => {
                        if (res.code == 0) {
                          this.$message.success("发放成功");
                        }
                        this.issueVisible = false;
                        loading.close();
                      })
                      .catch((err) => {
                        this.issueVisible = false;
                        loading.close();
                      });
                  })
                  .catch((action) => {
                    this.issueVisible = false;
                  });
              }

              if (!sending.length && !nobody.length) {
                let params = Object.assign({}, this.issueVisibleForm);
                const loading = this.$loading();
                marketing
                  .grantPlatformCouponGroup(params)
                  .then((res) => {
                    if (res.code == 0) {
                      this.$message.success("发放成功");
                    }
                    this.issueVisible = false;
                    loading.close();
                  })
                  .catch((err) => {
                    this.issueVisible = false;
                    loading.close();
                  });
              }
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.issueVisible = false;
    },

    // 添加
    addOrEditBtn(group_id) {
      this.$router.push({
        path: "/home/marketing/addEditCoupon",
        query: {
          group_id,
        },
      });
    },
    // 发放记录
    logListBtn(row) {
      this.couponVisibleForm.group_id = row.group_id;
      this.couponVisibleForm.group_coupon_name = row.group_coupon_name;
      this.getCouponList();
      this.couponVisible = true;
    },
    searchCouponVisibleList() {
      this.couponVisiblePagination.page = 1;
      this.getCouponList();
    },
    getCouponList() {
      let params = Object.assign(
        {},
        this.couponVisiblePagination,
        this.couponVisibleForm
      );
      this.couponVisibleTableLoading = true;
      marketing.grantCouponGroupList(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.couponVisibleTableData = data.list;
          this.couponVisibleTotalNum = data.total;
          this.couponVisibleTableLoading = false;
        }
      });
    },
    openLink(row) {
      this.linkInfo = {
        wechat_link_url_qrcode: row.wechat_link_url_qrcode,
        h5_link_url: row.h5_link_url,
        applet_link_url_qrcode: row.applet_link_url_qrcode,
        applet_link_url: row.applet_link_url,
      };
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    // 复制文本
    copyText(text) {
      const input = document.createElement("input");
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
      this.$message.success("复制成功");
    },

    // 下载图片
    downloadImage(url, filename) {
      // 创建隐藏的下载链接
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      a.download = filename;

      // 添加到DOM中并触发点击
      document.body.appendChild(a);
      a.click();

      // 清理DOM
      setTimeout(() => {
        document.body.removeChild(a);
      }, 100);
    },
    updateStatus(row, status) {
      let params = {
        group_id: row.group_id,
        status,
      };
      this.$confirm(
        "确定要" + (status == 0 ? "停发" : "恢复") + "吗？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        }
      )
        .then(() => {
          marketing.updatePlatformCouponStatus(params).then((res) => {
            let { code } = res;
            if (code == 0) {
              this.$message.success("操作成功");
              this.getList();
            }
          });
        })
        .catch(() => {});
    },
    // 统计
    toStatistics(row) {
      let { group_id, group_coupon_name } = row;
      this.$router.push({
        path: "/home/marketing/couponGroupStatistics",
        query: {
          group_id,
          group_coupon_name,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.platformCoupon-list {
  .top-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .search-box {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 10px;
    .item {
      height: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      span {
        display: inline-block;
        margin-right: 4px;
        text-align: right;
        white-space: nowrap;
        box-sizing: border-box;
      }
    }
    .item-content {
      // width: 100%;
      .el-date-editor {
        width: 100%;
      }
    }
  }
}
.platformCoupon-issue {
  .el-form-item {
    ::v-deep .el-form-item__content {
      height: auto;
    }
  }
  .is-msg {
    display: flex;
    ::v-deep .el-form-item__content {
      margin-left: 10px !important;
    }
  }
}
.qrcode-container {
  display: flex;
  justify-content: space-around;
  margin-bottom: 20px;
}

.qrcode-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.qrcode-img {
  width: 150px;
  height: 150px;
  margin-bottom: 10px;
}

.link-item {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.link-item span {
  width: 100px;
  flex-shrink: 0;
}
</style>
